import { useState, useEffect } from "react";
import { 
  FaPhone, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaClock, 
  FaCar,
  FaStar,
  FaUsers,
  FaWhatsapp,
  FaChevronRight,
  FaMap,
  FaHome,
  FaPlane,
  FaTrain,
  FaBriefcase,
  FaHeart,
  FaInstagram,
  FaFacebook,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
  FaHeadphones,
  FaInfoCircle,
  FaExternalLinkAlt,
  FaUser,
  FaMapPin,
  FaArrowRight
} from "react-icons/fa";

import { 
  MdPhoneOutgoing,
  MdEmail,
  MdAccessTime,
  MdSend,
  MdDirectionsCar,
  MdNavigation,
  MdMessage,
  MdError,
  MdSecurity,
  MdEmojiEvents,
  MdTrendingUp,
  MdFlight,
  MdTrain,
  MdBusinessCenter,
  MdHome,
  MdFreeBreakfast,
  MdFavorite,
  MdLanguage,
  MdLiveHelp,
  MdInfo,
  MdPerson,
  MdCalendarToday,
  MdWatchLater,
  MdMap,
  MdLocationOn,
  MdOutlinePhoneIncoming,
  MdOutlinePhoneOutgoing,
  MdOutlineEmail,
  MdOutlineAccessTime,
  MdOutlineSend,
  MdOutlineDirectionsCar,
  MdOutlineNavigation,
  MdOutlineMessage,
  MdOutlineError,
  MdOutlineSecurity,
  MdOutlineEmojiEvents,
  MdOutlineTrendingUp,
  MdOutlineFlight,
  MdOutlineTrain,
  MdOutlineBusinessCenter,
  MdOutlineHome,
  MdOutlineFreeBreakfast,
  MdOutlineFavorite,
  MdOutlineLanguage,
  MdOutlineLiveHelp,
  MdOutlineInfo,
  MdOutlinePerson,
  MdOutlineCalendarToday,
  MdOutlineWatchLater,
  MdOutlineMap,
  MdOutlineLocationOn
} from "react-icons/md";

import { 
  RiWhatsappLine,
  RiCustomerServiceLine,
  RiShieldLine,
  RiAwardLine,
  RiHeartLine,
  RiTaxiLine,
  RiMapPinLine,
  RiTimeLine,
  RiSendPlaneLine,
  RiArrowRightSLine,
  RiNavigationLine,
  RiCheckLine,
  RiAlertLine
} from "react-icons/ri";

const P = "#28aa96";
const D = "#1e7467";

function inject() {
  if (document.getElementById("stc-styles")) return;
  const s = document.createElement("style");
  s.id = "stc-styles";
  s.textContent = `
   
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    body { background: #f0faf8; }

    .stc-root {
      background: #f0faf8;
      min-height: 100vh;
      color: #0f2925;
    }

    /* ── NAVBAR ── */
    .stc-nav {
      background: ${D};
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 48px;
      height: 68px;
      position: sticky;
      top: 0;
      z-index: 100;
      box-shadow: 0 2px 20px rgba(0,0,0,0.15);
    }
    .stc-nav-logo {
      display: flex; align-items: center; gap: 10px;
      color: #fff; font-size: 18px; font-weight: 700; letter-spacing: -0.3px;
    }
    .stc-nav-links {
      display: flex; gap: 32px;
    }
    .stc-nav-links a {
      color: rgba(255,255,255,0.75); text-decoration: none;
      font-size: 14px; font-weight: 500; transition: color 0.2s;
      display: flex; align-items: center; gap: 6px;
    }
    .stc-nav-links a:hover { color: #fff; }
    .stc-nav-cta {
      background: ${P}; color: #fff; border: none;
      padding: 10px 22px; border-radius: 10px; font-size: 14px;
      cursor: pointer; transition: background 0.2s, transform 0.15s;
      display: flex; align-items: center; gap: 8px;
    }
    .stc-nav-cta:hover { background: #22c5ae; transform: translateY(-1px); }

    /* ── HERO ── */
   .stc-hero {
  background:  url('https://upload.wikimedia.org/wikipedia/commons/d/db/Chennai_Central_D.jpg');
  background-blend-mode: overlay;
  background-size: cover;
  background-position: center;
  padding: 90px 48px 110px;
  position: relative; 
  overflow: hidden;
  display: grid; 
  grid-template-columns: 1fr 1fr; 
  gap: 60px; 
  align-items: center;
}
    .stc-hero-bubble1 {
      position: absolute; width: 500px; height: 500px; border-radius: 50%;
      background: rgba(255,255,255,0.05); top: -150px; right: -100px; pointer-events: none;
    }
    .stc-hero-bubble2 {
      position: absolute; width: 280px; height: 280px; border-radius: 50%;
      background: rgba(255,255,255,0.06); bottom: -80px; left: 30%; pointer-events: none;
    }
    .stc-hero-left { position: relative; z-index: 2; }
    .stc-hero-tag {
      display: inline-flex; align-items: center; gap: 6px;
      background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.3);
      color: #fff; font-size: 11px; font-weight: 600; letter-spacing: 2px;
      text-transform: uppercase; padding: 6px 16px; border-radius: 50px; margin-bottom: 20px;
    }
    .stc-hero h1 {
      color: #fff; font-weight: 900; line-height: 1.05; letter-spacing: -2px; margin-bottom: 16px;
    }
    .stc-hero h1 em { font-style: italic; color: #9efcee; }
    .stc-hero p {
      color: rgba(255,255,255,0.8); font-size: 16px; font-weight: 300;
      line-height: 1.7; max-width: 420px; margin-bottom: 32px;
    }
    .stc-hero-btns { display: flex; gap: 14px; flex-wrap: wrap; }
    .stc-hero-btn-primary {
      background: #fff; color: ${D}; border: none; padding: 14px 28px;
      border-radius: 12px; font-size: 15px; 
      font-weight: 700; cursor: pointer; transition: transform 0.15s, box-shadow 0.15s;
      display: flex; align-items: center; gap: 8px;
    }
    .stc-hero-btn-primary:hover { transform: translateY(-2px); box-shadow: 0 10px 28px rgba(0,0,0,0.2); }
    .stc-hero-btn-secondary {
      background: #ffffff; color: #000000; border: 1.5px solid rgba(255,255,255,0.4);
      padding: 14px 28px; border-radius: 12px; font-size: 15px;
       sans-serif; font-weight: 600; cursor: pointer;
      transition: background 0.2s; display: flex; align-items: center; gap: 8px;
    }
    .stc-hero-btn-secondary:hover { background: #fffff; }
    .stc-hero-right { position: relative; z-index: 2; }
    .stc-hero-card {
      background: rgba(255,255,255,0.12); backdrop-filter: blur(20px);
      border: 1px solid rgba(255,255,255,0.25); border-radius: 24px; padding: 32px;
    }
    .stc-hero-card h3 {
       serif; color: #fff; font-size: 22px; margin-bottom: 20px;
      display: flex; align-items: center; gap: 8px;
    }
    .stc-stat-row { display: flex; gap: 16px; margin-bottom: 20px; }
    .stc-stat {
      flex: 1; background: rgba(255,255,255,0.1); border-radius: 14px;
      padding: 16px; text-align: center;
    }
    .stc-stat-num { font-size: 28px; font-weight: 800; color: #fff; letter-spacing: -1px; display: flex; align-items: center; justify-content: center; gap: 4px; }
    .stc-stat-lbl { font-size: 11px; color: rgba(255,255,255,0.65); margin-top: 4px; font-weight: 500; letter-spacing: 0.5px; }
    .stc-live-row {
      display: flex; align-items: center; justify-content: space-between;
      background: rgba(255,255,255,0.1); border-radius: 12px; padding: 14px 16px;
    }
    .stc-live-dot {
      width: 10px; height: 10px; background: #4cfa8f; border-radius: 50%;
      animation: livePulse 1.5s ease-in-out infinite;
    }
    @keyframes livePulse { 0%,100%{opacity:1} 50%{opacity:0.3} }
    .stc-live-text { color: #fff; font-size: 13px; font-weight: 600; display: flex; align-items: center; gap: 8px; }
    .stc-live-badge { color: #4cfa8f; font-size: 12px; font-weight: 700; letter-spacing: 1px; }

    /* ── MAIN GRID ── */
    .stc-main {
      max-width: 1200px; margin: 0 auto; padding: 72px 48px 80px;
    }
    .stc-grid { display: grid; grid-template-columns: 1fr 1.4fr; gap: 48px; align-items: start; }

    /* ── SECTION HEADING ── */
    .stc-section-head { margin-bottom: 28px; }
    .stc-eyebrow {
      font-size: 11px; letter-spacing: 2.5px; text-transform: uppercase;
      color: ${P}; font-weight: 700; margin-bottom: 8px;
      display: flex; align-items: center; gap: 6px;
    }
    .stc-section-head h2 {
      font-size: 32px; color: #0f2925;
      letter-spacing: -1px; line-height: 1.15;
    }
    .stc-section-head h2 span { color: ${P}; }
    .stc-divider {
      width: 50px; height: 3px; background: linear-gradient(90deg, ${P}, ${D});
      border-radius: 2px; margin-top: 12px;
    }

    /* ── CONTACT CARDS ── */
    .stc-contact-card {
      display: flex; align-items: center; gap: 18px;
      background: #fff; border-radius: 18px; padding: 22px 24px;
      margin-bottom: 16px; text-decoration: none;
      border: 1px solid rgba(40,170,150,0.12);
      box-shadow: 0 2px 16px rgba(30,116,103,0.07);
      transition: transform 0.2s, box-shadow 0.2s;
    }
    .stc-contact-card:hover { transform: translateX(6px); box-shadow: 0 6px 28px rgba(30,116,103,0.14); }
    .stc-contact-icon {
      width: 54px; height: 54px; border-radius: 16px; flex-shrink: 0;
      background: linear-gradient(135deg, ${P}, ${D});
      display: flex; align-items: center; justify-content: center; font-size: 22px;
      color: #fff;
    }
    .stc-contact-lbl { font-size: 11px; color: #5a8a83; font-weight: 700; letter-spacing: 1.5px; text-transform: uppercase; margin-bottom: 4px; display: flex; align-items: center; gap: 4px; }
    .stc-contact-val { font-size: 16px; color: #0f2925; font-weight: 700; }
    .stc-contact-sub { font-size: 12px; color: #5a8a83; margin-top: 2px; display: flex; align-items: center; gap: 4px; }
    .stc-contact-arrow { margin-left: auto; color: ${P}; font-size: 22px; font-weight: 700; }

    /* ── LOCATION CARD ── */
    .stc-loc-card {
      background: #fff; border-radius: 20px; overflow: hidden;
      border: 1px solid rgba(40,170,150,0.12);
      box-shadow: 0 2px 16px rgba(30,116,103,0.07); margin-bottom: 16px;
    }
    .stc-map {
      height: 140px;
      background: linear-gradient(135deg, #d4f0eb, #b8e8e1);
      display: flex; flex-direction: column; align-items: center; justify-content: center;
      gap: 6px; position: relative; overflow: hidden;
    }
    .stc-map-grid {
      position: absolute; inset: 0;
      background-image: radial-gradient(circle, rgba(40,170,150,0.2) 1.5px, transparent 1.5px);
      background-size: 22px 22px;
    }
    .stc-map-pin { font-size: 36px; position: relative; z-index: 2; animation: pinFloat 2.5s ease-in-out infinite; }
    @keyframes pinFloat { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
    .stc-map-label { font-size: 13px; font-weight: 700; color: ${D}; position: relative; z-index: 2; display: flex; align-items: center; gap: 4px; }
    .stc-loc-body { padding: 18px 22px; display: flex; align-items: center; justify-content: space-between; }
    .stc-loc-title { font-size: 15px; font-weight: 700; color: #0f2925; display: flex; align-items: center; gap: 6px; }
    .stc-loc-sub { font-size: 12px; color: #5a8a83; margin-top: 3px; display: flex; align-items: center; gap: 4px; }
    .stc-maps-btn {
      background: linear-gradient(135deg, ${P}, ${D}); color: #fff;
      border: none; border-radius: 10px; padding: 10px 18px;
      font-size: 13px;  font-weight: 600;
      cursor: pointer; transition: transform 0.15s; display: flex; align-items: center; gap: 6px;
    }
    .stc-maps-btn:hover { transform: scale(1.04); }

    /* ── HOURS ── */
    .stc-hours {
      background: linear-gradient(135deg, ${D}, ${P});
      border-radius: 18px; padding: 20px 24px;
      display: flex; align-items: center; justify-content: space-between;
    }
    .stc-hours-left { display: flex; align-items: center; gap: 14px; }
    .stc-hours-title { color: #fff; font-size: 15px; font-weight: 700; display: flex; align-items: center; gap: 6px; }
    .stc-hours-sub { color: rgba(255,255,255,0.7); font-size: 12px; margin-top: 3px; display: flex; align-items: center; gap: 4px; }
    .stc-live-tag {
      background: #4cfa8f; color: #0a3d2e; font-size: 10px;
      font-weight: 800; padding: 6px 12px; border-radius: 50px; letter-spacing: 1.5px;
      text-transform: uppercase; display: flex; align-items: center; gap: 4px;
    }

    /* ── FORM ── */
    .stc-form-card {
      background: #fff; border-radius: 24px; padding: 44px 40px;
      border: 1px solid rgba(40,170,150,0.12);
      box-shadow: 0 4px 30px rgba(30,116,103,0.09);
    }
    .stc-form-title {  font-size: 28px; color: #0f2925; margin-bottom: 6px; letter-spacing: -0.8px; display: flex; align-items: center; gap: 8px; }
    .stc-form-sub { color: #5a8a83; font-size: 14px; margin-bottom: 28px; display: flex; align-items: center; gap: 6px; }
    .stc-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; }
    .stc-field { margin-bottom: 18px; }
    .stc-label {
      display: flex; align-items: center; gap: 6px; font-size: 11px; font-weight: 700; letter-spacing: 1.5px;
      text-transform: uppercase; color: ${D}; margin-bottom: 7px;
    }
    .stc-input {
      width: 100%; padding: 14px 16px; border-radius: 12px;
      border: 1.5px solid rgba(40,170,150,0.2); background: #f0faf8;
      font-size: 14px;  color: #0f2925;
      outline: none; transition: all 0.2s;
    }
    .stc-input:focus { border-color: ${P}; background: #fff; box-shadow: 0 0 0 4px rgba(40,170,150,0.1); }
    .stc-textarea { min-height: 110px; resize: vertical; }
    .stc-submit {
      width: 100%; padding: 16px; border-radius: 14px;
      background: linear-gradient(135deg, ${P}, ${D}); color: #fff; border: none;
      font-size: 15px;  font-weight: 700;
      cursor: pointer; letter-spacing: 0.3px; margin-top: 4px;
      box-shadow: 0 6px 20px rgba(30,116,103,0.3);
      transition: transform 0.15s, box-shadow 0.15s;
      display: flex; align-items: center; justify-content: center; gap: 8px;
    }
    .stc-submit:hover { transform: translateY(-2px); box-shadow: 0 12px 30px rgba(30,116,103,0.4); }
    .stc-success {
      background: #e6faf5; border: 1.5px solid ${P}; border-radius: 12px;
      padding: 14px 18px; margin-bottom: 20px; font-size: 14px;
      color: ${D}; font-weight: 600; display: flex; align-items: center; gap: 8px;
    }

    /* ── QUICK BAR (desktop) ── */
    .stc-quick-bar {
      background: rgba(255,255,255,0.9); backdrop-filter: blur(12px);
      border-top: 1px solid rgba(40,170,150,0.15);
      display: flex; justify-content: center; gap: 0;
      padding: 0; max-width: 1200px; margin: 0 auto 0;
      border-radius: 0 0 20px 20px;
      box-shadow: 0 8px 30px rgba(30,116,103,0.1);
      overflow: hidden;
    }
    .stc-qb-item {
      flex: 1; display: flex; align-items: center; justify-content: center;
      gap: 10px; padding: 16px 20px; text-decoration: none;
      font-size: 14px; font-weight: 600; color: ${D};
      transition: background 0.2s; border-right: 1px solid rgba(40,170,150,0.1);
    }
    .stc-qb-item:last-child { border-right: none; }
    .stc-qb-item:hover { background: rgba(40,170,150,0.08); }
    .stc-qb-icon { font-size: 18px; display: flex; align-items: center; }

    /* ── SOCIAL ICONS ── */
    .stc-social-grid {
      display: flex; gap: 12px; flex-wrap: wrap; margin-top: 16px;
    }
    .stc-social-icon {
      width: 44px; height: 44px; border-radius: 12px;
      background: linear-gradient(135deg, ${P}, ${D});
      color: #fff; display: flex; align-items: center; justify-content: center;
      font-size: 20px; transition: transform 0.15s, box-shadow 0.15s;
      text-decoration: none;
    }
    .stc-social-icon:hover { transform: translateY(-3px); box-shadow: 0 8px 16px rgba(30,116,103,0.3); }

    /* ── FEATURE GRID ── */
    .stc-feature-grid {
      display: grid; grid-template-columns: repeat(2,1fr); gap: 12px; margin-top: 20px;
    }
    .stc-feature-item {
      background: #fff; border-radius: 14px; padding: 14px;
      border: 1px solid rgba(40,170,150,0.1);
      display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600;
    }
    .stc-feature-icon {
      color: ${P}; font-size: 18px;
    }

    /* ── FOOTER ── */
    .stc-footer {
      background: ${D}; color: rgba(255,255,255,0.6);
      padding: 36px 48px; display: flex; align-items: center;
      justify-content: space-between; font-size: 13px;
    }
    .stc-footer-brand { color: #fff; font-size: 16px; font-weight: 700; margin-bottom: 4px; display: flex; align-items: center; gap: 6px; }
    .stc-footer-links { display: flex; gap: 24px; }
    .stc-footer-links a { color: rgba(255,255,255,0.6); text-decoration: none; transition: color 0.2s; display: flex; align-items: center; gap: 6px; }
    .stc-footer-links a:hover { color: #fff; }

    /* ── RESPONSIVE ── */
    @media (max-width: 900px) {
      .stc-nav { padding: 0 24px; }
      .stc-nav-links { display: none; }
      .stc-hero { grid-template-columns: 1fr; padding: 56px 24px 72px; gap: 36px; }
      .stc-hero-right { display: none; }
      .stc-main { padding: 48px 20px 60px; }
      .stc-grid { grid-template-columns: 1fr; gap: 40px; }
      .stc-form-card { padding: 28px 20px; }
      .stc-form-row { grid-template-columns: 1fr; }
      .stc-quick-bar { flex-wrap: wrap; }
      .stc-qb-item { flex: 1 1 33%; min-width: 120px; }
      .stc-footer { flex-direction: column; gap: 20px; text-align: center; padding: 28px 20px; }
      .stc-footer-links { justify-content: center; }
    }

    @media (max-width: 560px) {
      .stc-hero h1 { font-size: 34px; }
      .stc-hero { padding: 48px 20px 64px; }
      .stc-hero-btns { flex-direction: column; }
      .stc-nav-cta { display: none; }
      .stc-section-head h2 { font-size: 26px; }
      .stc-qb-item span:last-child { display: none; }
      .stc-qb-icon { font-size: 22px; }
    }
  `;
  document.head.appendChild(s);
}

export default function SafeTrackContactFull() {
  inject();

  const [form, setForm] = useState({ name: "", phone: "", email: "", pickup: "", msg: "" });
  const [sent, setSent] = useState(false);

  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const submit = () => {
    if (!form.name || !form.phone) return;
    setSent(true);
    setForm({ name: "", phone: "", email: "", pickup: "", msg: "" });
    setTimeout(() => setSent(false), 4000);
  };

  const contactItems = [
    { icon: <FaPhone />, label: "Primary Line", value: "+91 91504 10309", sub: "Tap to call directly", href: "tel:+919150410309" },
    { icon: <FaPhone />, label: "Alternate Line", value: "+91 91504 10309", sub: "Tap to call directly", href: "tel:+919150410309" },
    { icon: <FaEnvelope />, label: "Email Us", value: "safetrackcabservice@gmail.com", sub: "We reply within 24 hrs", href: "mailto:safetrackcabservice@gmail.com" },
  ];

  const socialLinks = [
    { icon: <FaInstagram />, href: "#", label: "Instagram" },
    { icon: <FaFacebook />, href: "#", label: "Facebook" },
    { icon: <FaTwitter />, href: "#", label: "Twitter" },
    { icon: <FaYoutube />, href: "#", label: "YouTube" },
    { icon: <FaLinkedin />, href: "#", label: "LinkedIn" },
  ];

  const features = [
    { icon: <MdSecurity />, text: "Safe & Secure Rides" },
    { icon: <FaClock />, text: "24/7 Availability" },
    { icon: <MdEmojiEvents />, text: "Professional Drivers" },
    { icon: <MdTrendingUp />, text: "Best Rates" },
    { icon: <FaHeart />, text: "100% Satisfaction" },
    { icon: <RiCustomerServiceLine />, text: "Customer First" },
  ];

  const services = [
    { icon: <FaPlane />, text: "Airport Transfers" },
    { icon: <FaTrain />, text: "Railway Station" },
    { icon: <FaBriefcase />, text: "Corporate Rides" },
    { icon: <FaHome />, text: "Local Trips" },
    { icon: <MdNavigation />, text: "Outstation" },
    { icon: <MdFreeBreakfast />, text: "Hourly Rentals" },
  ];

  return (
    <div className="stc-root">

      {/* ── NAVBAR ── */}
   

      {/* ── HERO ── */}
      <section className="stc-hero">
        <div className="stc-hero-bubble1" />
        <div className="stc-hero-bubble2" />

        <div className="stc-hero-left">
          <div className="stc-hero-tag">
            <FaMapMarkerAlt /> Chennai · Available 24/7
          </div>
          <h1>
            Your Ride,<br />
            <em>Your Way</em>
          </h1>
          <p>
            Safe Track Cab Service — Chennai's most trusted cab partner.
            Reach us anytime, anywhere across the city.
          </p>
          <div className="stc-hero-btns">
            <button className="stc-hero-btn-primary" onClick={() => window.location.href = "tel:+919150410309"}>
              <FaPhone /> Call Now
            </button>
            <button className="stc-hero-btn-secondary" onClick={() => window.location.href = "https://wa.me/919150410309"}>
              <FaWhatsapp /> WhatsApp Us
            </button>
          </div>
        </div>

        <div className="stc-hero-right">
          <div className="stc-hero-card">
            <h3><FaCar /> At a Glance</h3>
            <div className="stc-stat-row">
              <div className="stc-stat">
                <div className="stc-stat-num"><FaUsers /> 5000+</div>
                <div className="stc-stat-lbl">Happy Rides</div>
              </div>
              <div className="stc-stat">
                <div className="stc-stat-num"><FaStar /> 4.9★</div>
                <div className="stc-stat-lbl">Avg. Rating</div>
              </div>
              <div className="stc-stat">
                <div className="stc-stat-num"><FaClock /> 24/7</div>
                <div className="stc-stat-lbl">Availability</div>
              </div>
            </div>
            <div className="stc-live-row">
              <div className="stc-live-text">
                <div className="stc-live-dot" />
                <MdNavigation /> Drivers available now in Chennai
              </div>
              <span className="stc-live-badge"><RiAlertLine /> LIVE</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── QUICK ACTION BAR ── */}
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 48px" }}>
        <div className="stc-quick-bar">
          <a href="tel:+919150410309" className="stc-qb-item">
            <span className="stc-qb-icon"><FaPhone /></span>
            <span>Call +91 91504 10309</span>
          </a>
          <a href="tel:+919150410309" className="stc-qb-item">
            <span className="stc-qb-icon"></span>
            <span>Call +91 91504 10309</span>
          </a>
          <a href="mailto:safetrackcabservice@gmail.com" className="stc-qb-item">
            <span className="stc-qb-icon"><FaEnvelope /></span>
            <span>safetrackcabservice@gmail.com</span>
          </a>
          <a href="https://wa.me/919150410309" className="stc-qb-item">
            <span className="stc-qb-icon"><FaWhatsapp /></span>
            <span>WhatsApp Us</span>
          </a>
        </div>
      </div>

      {/* ── MAIN CONTENT ── */}
      <main className="stc-main">
        <div className="stc-grid">

          {/* ── LEFT COL ── */}
          <div>
            <div className="stc-section-head">
              <div className="stc-eyebrow"><FaPhone /> Contact Details</div>
              <h2>Reach Us <span>Anytime</span></h2>
              <div className="stc-divider" />
            </div>

            {contactItems.map((item) => (
              <a key={item.value} href={item.href} className="stc-contact-card">
                <div className="stc-contact-icon">{item.icon}</div>
                <div>
                  <div className="stc-contact-lbl"><FaInfoCircle size={12} /> {item.label}</div>
                  <div className="stc-contact-val">{item.value}</div>
                  <div className="stc-contact-sub"><RiCustomerServiceLine size={12} /> {item.sub}</div>
                </div>
                <span className="stc-contact-arrow"><FaChevronRight /></span>
              </a>
            ))}

            <div className="stc-social-grid">
              {socialLinks.map((social, idx) => (
                <a key={idx} href={social.href} className="stc-social-icon" target="_blank" rel="noopener noreferrer" title={social.label}>
                  {social.icon}
                </a>
              ))}
            </div>

            <div style={{ marginTop: 24 }}>
              <div className="stc-section-head">
                <div className="stc-eyebrow"><FaMapMarkerAlt /> Find Us</div>
                <h2>Our <span>Location</span></h2>
                <div className="stc-divider" />
              </div>
              <div className="stc-loc-card">
               <div className="stc-map">
  {/* Replace the gradient background with actual map */}
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d497511.11464177556!2d79.92880441264663!3d13.047986895307802!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265ea4f7d3361%3A0x6e61a70b6863d433!2sChennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1709812345678!5m2!1sen!2sin"
    width="100%"
    height="100%"
    style={{ border: 0, position: 'absolute', top: 0, left: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Chennai Map"
  />
  {/* Optional overlay pin */}
  <div style={{ 
    position: 'absolute', 
    bottom: '10px', 
    left: '50%', 
    transform: 'translateX(-50%)',
    background: 'rgba(255,255,255,0.9)',
    padding: '4px 12px',
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    zIndex: 10
  }}>
    <FaMapPin style={{ color: '#28aa96' }} />
    <span style={{ fontSize: '12px', fontWeight: '600', color: '#1e7467' }}>Chennai, Tamil Nadu</span>
  </div>
</div>
                <div className="stc-loc-body">
                  <div>
                    <div className="stc-loc-title"><FaMap /> Safe Track Cab Service</div>
                    <div className="stc-loc-sub"><FaMapMarkerAlt size={12} /> Chennai, Tamil Nadu, India</div>
                  </div>
                  <button className="stc-maps-btn" onClick={() => window.open("https://maps.google.com/?q=Chennai,Tamil+Nadu", "_blank")}>
                    <FaMap /> Open Maps <FaExternalLinkAlt size={12} />
                  </button>
                </div>
              </div>

              <div className="stc-hours">
                <div className="stc-hours-left">
                  <FaClock size={32} />
                  <div>
                    <div className="stc-hours-title"><MdCalendarToday /> Open Every Day</div>
                    <div className="stc-hours-sub"><MdAccessTime size={12} /> Mon – Sun · Including All Holidays</div>
                  </div>
                </div>
                <span className="stc-live-tag"><RiAlertLine size={12} /> LIVE</span>
              </div>

              {/* Features Grid */}
              <div className="stc-feature-grid">
                {features.map((feature, idx) => (
                  <div key={idx} className="stc-feature-item">
                    <span className="stc-feature-icon">{feature.icon}</span>
                    <span>{feature.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ── RIGHT COL — FORM ── */}
          <div>
            <div className="stc-section-head">
              <div className="stc-eyebrow"><FaCar /> Book a Ride</div>
              <h2>Send Us a <span>Message</span></h2>
              <div className="stc-divider" />
            </div>
            <div className="stc-form-card">
              <div className="stc-form-title">
                <MdSend /> Get in Touch
              </div>
              <div className="stc-form-sub">
                <FaHeadphones size={16} /> We'll get back to you within minutes
              </div>

              {sent && (
                <div className="stc-success">
                  <RiCheckLine size={20} /> Message sent! We'll contact you shortly.
                </div>
              )}

              <div className="stc-form-row">
                <div className="stc-field">
                  <label className="stc-label"><FaUser size={12} /> Full Name</label>
                  <input className="stc-input" placeholder="John Doe" value={form.name} onChange={set("name")} />
                </div>
                <div className="stc-field">
                  <label className="stc-label"><FaPhone size={12} /> Phone Number</label>
                  <input className="stc-input" placeholder="9876543210" type="tel" value={form.phone} onChange={set("phone")} />
                </div>
              </div>

              <div className="stc-field">
                <label className="stc-label"><FaEnvelope size={12} /> Email Address</label>
                <input className="stc-input" placeholder="you@example.com" type="email" value={form.email} onChange={set("email")} />
              </div>

              <div className="stc-field">
                <label className="stc-label"><FaMapMarkerAlt size={12} /> Pickup Location</label>
                <input className="stc-input" placeholder="e.g. Chennai Airport, T Nagar..." value={form.pickup} onChange={set("pickup")} />
              </div>

              <div className="stc-field">
                <label className="stc-label"><MdMessage size={12} /> Message / Details</label>
                <textarea className="stc-input stc-textarea" placeholder="Tell us where you'd like to go, any special requirements..." value={form.msg} onChange={set("msg")} />
              </div>

              {/* Services Selection */}
              <div style={{ marginBottom: 16 }}>
                <label className="stc-label"><FaCar size={12} /> Service Type</label>
                <div className="stc-feature-grid">
                  {services.map((service, idx) => (
                    <div key={idx} className="stc-feature-item" style={{ cursor: 'pointer' }}>
                      <span className="stc-feature-icon">{service.icon}</span>
                      <span>{service.text}</span>
                    </div>
                  ))}
                </div>
              </div>

              <button className="stc-submit" onClick={submit}>
                <MdSend /> Send Message & Book Ride <FaArrowRight />
              </button>
            </div>
          </div>

        </div>
      </main>

      {/* ── FOOTER ── */}
     

    </div>
  );
}
